// This file is automatically generated from ingestAssets.mjs
import * as React from 'react';
import IconContainer, { IconProps } from '../../../components/IconContainer';

export function BellSlashBoldIcon(props: IconProps) {
	return (
		<IconContainer {...props}>
			{
				<svg
					xmlns="http://www.w3.org/2000/svg"
					width="100%"
					height="100%"
					fill="none"
					viewBox="0 0 32 32"
				>
					<path
						fill="currentColor"
						d="m27.11 25.991-20-22A1.5 1.5 0 1 0 4.89 6.01l1.85 2.036A10.447 10.447 0 0 0 5.5 13c0 3.198-.574 5.875-1.659 7.741a2.51 2.51 0 0 0 .907 3.428c.38.22.813.334 1.252.331h4.524a5.5 5.5 0 0 0 10.952 0h.224l3.19 3.509a1.5 1.5 0 0 0 2.22-2.018ZM8.5 13a7.48 7.48 0 0 1 .44-2.536L18.973 21.5H6.835C7.94 19.25 8.5 16.392 8.5 13ZM16 26.5a2.5 2.5 0 0 1-2.45-2h4.9a2.5 2.5 0 0 1-2.45 2ZM11.111 5.294a1.501 1.501 0 0 1 .796-1.966A10.5 10.5 0 0 1 26.5 13c0 2.335.297 4.366.884 6.035a1.501 1.501 0 1 1-2.83 1c-.7-1.995-1.054-4.36-1.054-7.035a7.499 7.499 0 0 0-10.422-6.91 1.5 1.5 0 0 1-1.967-.796Z"
					/>
				</svg>
			}
		</IconContainer>
	);
}
